import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

import "./report.scss";

export default function Report({ name, description, icon, handleClick }) {
  return (
    <Button
      variant="default"
      onClick={handleClick}
      className="btn-list-view btn-list-view--lg btn-list-view-with-border fw-normal report-btn"
    >
      <Stack direction="horizontal" gap={3} className={`report ${icon}`}>
        <Stack className="justify-content-around">
          <h1 className="mb-0 small small-bold">{name}</h1>
          <p className="mt-0 caption text-wrap lh-base">{description}</p>
        </Stack>
      </Stack>
    </Button>
  );
}
